<template>
    <div>


        <a @click="assistenza" class="btn btn-primary">{{$t('support')}}</a>

        <b-modal id="registrati" title="Registrati" ref="assistenza" @ok="doAssistenza" @show="assistenzaOpen">
            <b-form @submit="doRegister">
                <b-form-input v-model="register.email" v-validate="'required|email'" data-vv-name="email"
                              placeholder="E-Mail"></b-form-input>
                <span v-show="errors.has('email')" class="error">{{ errors.first('email') }}</span>

                <b-form-input v-model="register.password" type="password" data-vv-name="password"
                              v-validate="'required|min:6|max:8'" ref="password" placeholder="Password"></b-form-input>
                <span v-show="errors.has('password')" class="error">{{ errors.first('password') }}</span>

                <b-form-input type="password" v-validate="'required|confirmed:password'" placeholder="Retype Password"
                              data-vv-name="password_confirm"></b-form-input>
                <span v-show="errors.has('password_confirm')" class="error">{{ errors.first('password_confirm')
                    }}</span>


                <b-form-input v-model="register.name" v-validate="'required|min:2|max:16'" data-vv-name="name"
                              placeholder="Nome"></b-form-input>
                <span v-show="errors.has('name')" class="error">{{ errors.first('name') }}</span>

                <b-form-input v-model="register.surname" v-validate="'required|min:2|max:16'" data-vv-name="surname"
                              placeholder="Cognome"></b-form-input>
                <span v-show="errors.has('surname')" class="error">{{ errors.first('surname') }}</span>


                <b-form-input v-model="register.birthdate" v-validate="'required|date_format:yyyy-MM-dd'" type="date"
                              data-vv-name="birthdate" placeholder="Data di nascita"></b-form-input>
                <span v-show="errors.has('birthdate')" class="error">{{ errors.first('birthdate') }}</span>


                <b-form-select v-model="register.sex" v-validate="'required'" data-vv-name="sex"
                               :options="$t('sesso')"></b-form-select>
                <span v-show="errors.has('sex')" class="error">{{ errors.first('sex') }}</span>

                <b-form-select v-model="register.country" :options="country"></b-form-select>

                <b-form-select v-model="register.region" :options="region"
                               v-if="register.country === 'ITA'"></b-form-select>

                <b-form-select v-model="sel.discriplines" multiple :select-size="5"
                               :options="disciplines"></b-form-select>

            </b-form>
        </b-modal>
    </div>
</template>

<script>
    export default {
        name: "Assistenza",
        props: [],
        computed: {
            opt_assistenza() {
                return this.optsFromTable(this.raw_opt_assistenza)
            }
        },
        data() {
          return {
              assistenza: {},
              raw_opt_assistenza: []
            }
        },
        methods: {
            async assistenzaOpen() {
                if (this.opt_assistenza.length > 0) return true
                let data = await this.get('table/raceissue')
                this.raw_opt_assistenza = data.GenericTables
            }, optsFromTable(values) {
                if (values.length <= 0) return [{value: -1, text: ' - '}]
                let opts = []
                for (let i = 0; i < values.length; i++)
                    opts.push({value: values[i].Code, text: values[i].Description})
                return opts
            },
            async doAssistenza() {

            }
        }
    }
</script>

<style scoped>

</style>
